import Cookies from 'js-cookie'

type SourceType = 'super_app' | 'web'

const getSourceType = () => {
  return (Cookies.get('source') || 'web') as SourceType
}

export { type SourceType, getSourceType }
